import { useActiveCoachReviewsContext } from "./useActiveCoachReviewsContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCoachReviewsStore, getDraftKey } from "common/src/gamePage/stores/coach-reviews.store";

export const useSendTeamReview = () => {
	const queryClient = useQueryClient();
	const { userId, gameId, promises } = useActiveCoachReviewsContext();
	const clearDraft = useCoachReviewsStore((state) => state.clearDraft);

	if (!promises) {
		throw new Error("Coach review promises are not available");
	}

	return useMutation({
		mutationFn: promises.sendTeamReview,
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ["coachReviews", gameId] });
			queryClient.invalidateQueries({ queryKey: ["coachReviewsSummary", gameId] });
			// TODO: Update the query cache
			// queryClient.setQueryData(["coachReviews", gameId], (oldData) => {
			// 	return {
			// 		...oldData,
			// 	};
			// });
			// Remove draft from local state and local storage
			const draftKey = getDraftKey({ kind: "team", userId: userId, gameId: gameId, teamId: variables.id });
			clearDraft(draftKey);
		},
		onError: (error) => {
			// TODO: Give error feedback
		},
	});
};
